import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {uploadCover} from '@client/upload-cover'
import {Action} from './action'
import DownloadIcon from './icons/upload-cover.svg'
import DownloadActiveIcon from './icons/upload-cover-active.svg'
import DownloadHoverIcon from './icons/upload-cover-hover.svg'

interface Props {
  hub: Hub
  className?: string
}

export const Upload = ({hub, className}: Props) => {
  const onClick = () => uploadCover(hub)

  return (
    <Action
      onClick={onClick}
      className={className}
      icon={<DownloadIcon />}
      hovered={<DownloadHoverIcon />}
      active={<DownloadActiveIcon />}
      tooltip={Lang.msg.uploadTaskImage}
    />
  )
}
